module.exports = __webpack_public_path__ + "static/media/mh.23c05fb6.svg";